export default __webpack_public_path__ + "static/media/mic.7a73c4c9.svg";